import { UniDriver } from '@wix/unidriver-core';
import { codeSnippetUniDriverFactory as publicDriverFactory } from './CodeSnippet.uni.driver';
import { DATA_HOOKS } from './CodeSnippet.constants';
import { classes as blockClasses } from './CodeSnippet.st.css';
import { classes as inlineClasses } from './components/InlineVariant.st.css';

export const codeSnippetPrivateDriverFactory = (
  base: UniDriver,
  body?: UniDriver,
) => {
  // Inline variant is portal'd by Tooltip, so we query from `body` rather
  // than `base` to reach it.
  const rootSelector = `.${blockClasses.root}, .${inlineClasses.root}`;

  const root = () => (body ?? base).$(rootSelector);
  const copyButton = () => root().$(`[data-hook="${DATA_HOOKS.copyButton}"]`);
  const code = () => root().$(`[data-hook="${DATA_HOOKS.code}"]`);

  return {
    ...publicDriverFactory(base, body),

    /** Presses a key on the snippet root (e.g. Enter/Space to copy the inline variant). */
    pressKey: (key: string) =>
      root().pressKey(key as Parameters<UniDriver['pressKey']>[0]),

    /** The copy button's `aria-describedby`, used to associate it with the code block. */
    getCopyButtonDescribedBy: () => copyButton().attr('aria-describedby'),

    /** The code element's `id`, referenced by the copy button's `aria-describedby`. */
    getCodeId: () => code().attr('id'),
  };
};

export type CodeSnippetPrivateDriver = ReturnType<
  typeof codeSnippetPrivateDriverFactory
>;
